<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="2000916">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleServiceBO.ajax?cmd=doQueryVehicleWaringList"
          :params="fullSearchData"
          bizName="客户线路数据导出"
          bizCode="exp100020"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="2000915">
                  <span class="primary cur" @click="toApplyList(scope.row)">查看</span>
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  invoiceUrgeList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '时间',
          },
          {
            prop: 'hurryUserName',
            label: '催票方',
          },
          {
            prop: 'applyNum',
            label: '申请号码',
          },
          {
            prop: 'remark',
            label: '备注',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: invoiceUrgeList,
    toApplyList (item) {
      this.jump({
        label: '开票申请',
        url: '/manage/operate/invoice/register?applyNum=' + item.applyNum,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
